import GokuDataGrid from '@/components/GokuDataGrid'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { useModal } from '@/contexts/modal'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import AddIcons from '@/icons/AddIcons'
import DeleteOutlineIcons from '@/icons/DeleteOutlineIcons'
import EditIcons from '@/icons/EditIcons'
import { CreateTargetModalProps } from '@/modals/EmployeeTargetModals/Create'
import { useTranslation } from 'react-i18next'
import { Button } from 'vnetwork-ui'
import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'
import { IAction } from 'vnetwork-ui/dist/components/GokuDataGrid/Actions'
import { deleteSalesTarget, getSalesTargets } from '../../../services'
import { SalesTarget, SalesTargetFilters } from '../../../types'
import { targetsColumns } from './columns'

interface ListProps {
    filters: SalesTargetFilters
}

const List = ({ filters }: ListProps) => {
    const { t } = useTranslation()

    const { setModal } = useModal()

    const { mutateAsync: deleteTarget, isPending: isDeleting } =
        useMutationWithHandler(
            {
                mutationFn: deleteSalesTarget,
            },
            {
                reactQueryKeys: QUERY_KEYS.REPORTS_BUSINESS_TARGETS,
            }
        )

    const dataGridActions: IAction<SalesTarget>[] = [
        {
            title: t('employees.performance.edit_target'),
            onClick: (row: SalesTarget) => {
                console.log(row)
                return setModal<CreateTargetModalProps>(
                    'EmployeeTargetModals/Create/index',
                    {
                        editTarget: row,
                    }
                )
            },
            color: 'primary',
            icon: <EditIcons />,
        },
        {
            title: t('delete'),
            onClick: async (row: SalesTarget) => await deleteTarget(row.id),
            color: 'error',
            icon: <DeleteOutlineIcons />,
            disabled: () => isDeleting,
        },
    ]
    return (
        <GokuDataGrid
            columns={targetsColumns(t)}
            apiCall={(payload: DataGridPayload) =>
                getSalesTargets({
                    ...filters,
                    ...payload,
                })
            }
            options={{
                showSearch: true,
                showHideColumn: false,
                pageSize: 10,
                title: (
                    <div className="flex justify-end pe-4 pb-2">
                        <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            startIcon={<AddIcons />}
                            onClick={() =>
                                setModal<CreateTargetModalProps>(
                                    'EmployeeTargetModals/Create/index'
                                )
                            }
                        >
                            {t('employees.performance.create_target')}
                        </Button>
                    </div>
                ),
            }}
            dataGridProps={{
                getRowId: (row) => row.id,
            }}
            reactQueryKey={[
                QUERY_KEYS.REPORTS_BUSINESS_TARGETS,
                'target-management',
                filters,
            ].join('|')}
            actions={dataGridActions}
        />
    )
}

export default List
